var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper"},[_c('img',{staticClass:"image__item",class:_vm.imageClass,attrs:{"data-url":_vm.source,"alt":_vm.alternateText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }